// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"8097":"7f5c199186ce2b90","9223":"8755e5cc98abf493"}[chunkId] + ".js";
};